import React from 'react';

const BarrelIcon = ({ width = 22, height = 22, fill1 = '#ffbd4a', fill2 = '#363636' }) => (
  <svg
    id="duotone"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path d="M14.3,15H49.7a1,1,0,0,0,.93-1.369,38.907,38.907,0,0,0-2.484-5.166A5,5,0,0,0,43.831,6H20.169a5,5,0,0,0-4.311,2.465,38.757,38.757,0,0,0-2.485,5.166A1,1,0,0,0,14.3,15Z" fill={fill1} />
    <path d="M49.7,49H14.3a1,1,0,0,0-.93,1.369,38.757,38.757,0,0,0,2.485,5.166A5,5,0,0,0,20.169,58H43.831a5,5,0,0,0,4.311-2.465,38.757,38.757,0,0,0,2.485-5.166A1,1,0,0,0,49.7,49Z" fill={fill1} />
    <path d="M52.566,19.764A1,1,0,0,0,51.6,19H12.405a1,1,0,0,0-.971.764,52.921,52.921,0,0,0,0,24.472,1,1,0,0,0,.971.764H51.6a1,1,0,0,0,.971-.764,52.921,52.921,0,0,0,0-24.472Z" fill={fill1} />
    
    <path d="M53,21H11a1,1,0,0,1,0-2H53a1,1,0,0,1,0,2Z" fill={fill2} />
    <path d="M51,15H13a1,1,0,0,1,0-2H51a1,1,0,0,1,0,2Z" fill={fill2} />
    <path d="M51,51H13a1,1,0,0,1,0-2H51a1,1,0,0,1,0,2Z" fill={fill2} />
    <path d="M53,45H11a1,1,0,0,1,0-2H53a1,1,0,0,1,0,2Z" fill={fill2} />
    <path d="M40.4,45c-.034,0-.069,0-.1-.005a1,1,0,0,1-.891-1.1A115.447,115.447,0,0,0,40,32a115.447,115.447,0,0,0-.6-11.9,1,1,0,1,1,1.989-.208A117.218,117.218,0,0,1,42,32a117.218,117.218,0,0,1-.608,12.1A1,1,0,0,1,40.4,45Z" fill={fill2} />
    <path d="M23.6,45a1,1,0,0,1-.994-.9A117.218,117.218,0,0,1,22,32a117.218,117.218,0,0,1,.608-12.1A1,1,0,1,1,24.6,20.1,115.447,115.447,0,0,0,24,32a115.447,115.447,0,0,0,.6,11.9,1,1,0,0,1-.891,1.1C23.671,45,23.636,45,23.6,45Z" fill={fill2} />
    <path d="M39.583,15a1,1,0,0,1-.985-.833c-.19-1.119-.381-2.1-.563-2.96a1,1,0,1,1,1.957-.414c.186.88.383,1.891.578,3.04a1,1,0,0,1-.819,1.153A.96.96,0,0,1,39.583,15Z" fill={fill2} />
    <path d="M24.417,15a.96.96,0,0,1-.168-.014,1,1,0,0,1-.819-1.153c.2-1.149.392-2.16.578-3.04a1,1,0,1,1,1.957.414c-.182.857-.373,1.841-.563,2.96A1,1,0,0,1,24.417,15Z" fill={fill2} />
    <path d="M39.015,54a1.056,1.056,0,0,1-.208-.021,1,1,0,0,1-.772-1.186c.182-.857.373-1.841.563-2.96a1,1,0,1,1,1.972.334c-.2,1.149-.392,2.16-.578,3.04A1,1,0,0,1,39.015,54Z" fill={fill2} />
    <path d="M24.985,54a1,1,0,0,1-.977-.793c-.186-.88-.383-1.891-.578-3.04a1,1,0,0,1,1.972-.334c.19,1.119.381,2.1.563,2.96a1,1,0,0,1-.772,1.186A1.056,1.056,0,0,1,24.985,54Z" fill={fill2} />
  </svg>
);

export default BarrelIcon;
